<template>
  <div id="app">
    <pts-header/>
    <pts-news/>
    <pts-gallery/>
    <pts-contact/>
    <pts-footer/>
  </div>
</template>

<script>
import Header from './components/Header.vue'
import News from './components/News.vue'
import Gallery from './components/Gallery.vue'
import Contact from './components/Contact.vue'
import Footer from './components/Footer.vue'

export default {
  name: 'app',
  components: {
    'pts-header': Header,
    'pts-news': News,
    'pts-gallery': Gallery,
    'pts-contact': Contact,
    'pts-footer': Footer
  }
}
</script>

<style>
html, body {
  margin: 0;
  background: #FFFFFF;
}

#app {
  width: 100%;
  height: 100%;
  font-family: 'Open Sans', sans-serif;
}

@media (max-width:575px) {
  .pts-container {
    width: 100%;
  }
}

@media (min-width: 576px) and (max-width:767px) {
  .pts-container {
    width: 540px;
  }
}

@media (min-width: 768px) and (max-width:991px) {
  .pts-container {
    width: 720px;
  }
}

@media (min-width: 992px) and (max-width:1199px) {
  .pts-container {
    width: 960px;
  }
}

@media (min-width: 1200px) {
  .pts-container {
    width: 1140px;
  }
}

.pts-container {
  margin: auto;
  color: #222222;
  font-size: 12px;
}

.pts-container h1 {
  text-transform: uppercase;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue